<script setup>
defineProps({
  lines: { type: Number, default: 1 },
  height: { type: String, default: 'h-4' },
});
</script>

<template>
  <div class="space-y-3 animate-pulse" aria-hidden="true">
    <div
      v-for="n in lines"
      :key="n"
      :class="['rounded-lg bg-deen-ink/[0.06]', height, n === lines && lines > 1 ? 'w-2/3' : 'w-full']"
    />
  </div>
</template>
